import { RootState } from "store/store";

const selectStatusPlan = (state: RootState) =>
  state.statusSlice.statusPlan ? state.statusSlice.statusPlan : [];

export const selectStatusById = (gridElementId: string) => {
  const selector = (state: RootState): string => {
    const data = selectStatusPlan(state).find(s => s.id == gridElementId);

    if (!data) return "LBR";
    return data?.status.toUpperCase();
  };
  (selector as any)._fromSelector = "statusSelector";
  return selector;
};
